import { useMutation } from '@tanstack/react-query'
import { deleteHistoryEntry } from '../api/plan-override-history-api'

export function useDeleteHistoryEntry(ruleBase: string) {
  return useMutation<void, unknown, string>({
    mutationFn: (logId) => deleteHistoryEntry(ruleBase, logId),
  })
}
